import { useState } from "react";

export const faqs = [
  {
    question: "Le devis est-il vraiment gratuit ?",
    answer: "Oui, absolument. Le déplacement d'un technicien et le diagnostic complet de votre volet roulant sont totalement gratuits et sans engagement. Le technicien examine votre volet, identifie la panne, et vous établit un devis détaillé. Si vous décidez de ne pas faire réparer, vous ne payez rien. Vous ne payez que si vous acceptez le devis et que nous réalisons l'intervention.",
  },
  {
    question: "Y a-t-il une majoration en soirée ou le week-end ?",
    answer: "Nous intervenons en soirée et le week-end pour les urgences. Si une majoration horaire s'applique, elle est toujours indiquée clairement dans le devis avant validation. Aucun supplément n'est appliqué sans votre accord préalable. Nos techniciens interviennent dans tout le Bas-Rhin, y compris les dimanches et jours fériés pour les dépannages urgents.",
  },
  {
    question: "Dois-je payer si le volet n'est pas réparable ?",
    answer: "Non. Si après diagnostic le technicien constate que votre volet n'est pas réparable, vous ne payez que le diagnostic si vous aviez convenu d'une intervention. Dans la pratique, le diagnostic est gratuit donc vous ne payez rien. Si un remplacement complet est nécessaire, nous vous proposons un devis détaillé pour la pose d'un nouveau volet. Vous restez libre d'accepter ou de refuser.",
  },
];

export default function FAQ() {
  const [open, setOpen] = useState<number | null>(0);

  return (
    <section className="bg-white py-14 md:py-20">
      <div className="max-w-4xl mx-auto px-4 md:px-8">
        <h2 className="text-2xl md:text-3xl font-bold text-brand-blue mb-8">
          Questions sur nos tarifs
        </h2>
        <div className="space-y-4">
          {faqs.map((faq, i) => (
            <div key={i} className="border border-brand-border rounded-xl overflow-hidden">
              <button
                onClick={() => setOpen(open === i ? null : i)}
                className="w-full flex items-center justify-between p-5 text-left hover:bg-brand-light/50 transition-colors"
              >
                <span className="font-semibold text-brand-blue text-sm md:text-base pr-4">{faq.question}</span>
                <i className={`ri-arrow-down-s-line text-brand-cyan text-xl transition-transform shrink-0 ${open === i ? "rotate-180" : ""}`}></i>
              </button>
              {open === i && (
                <div className="px-5 pb-5 text-sm text-brand-text leading-relaxed">
                  {faq.answer}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}